import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { IPLTradeLogo } from '../components/Layout';

export default function SeoArticlePage({ title, description, canonicalPath, keywords, heading, intro, sections }) {
  const canonicalUrl = `https://ipltrade.in${canonicalPath}`;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary)', padding: '2rem 1.25rem 3rem' }}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content="https://ipltrade.in/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="https://ipltrade.in/og-image.png" />
      </Helmet>

      <div style={{ maxWidth: 860, margin: '0 auto' }}>
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          <ArrowLeft size={15} /> Back to Home
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1rem' }}>
          <IPLTradeLogo size={34} />
          <span style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
            IPLTrade Insights
          </span>
        </div>

        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', lineHeight: 1.2, marginBottom: '0.75rem', color: 'var(--text-primary)' }}>
          {heading}
        </h1>

        <p style={{ color: 'var(--text-secondary)', fontSize: '1rem', lineHeight: 1.7, marginBottom: '1.5rem' }}>
          {intro}
        </p>

        <div style={{ display: 'grid', gap: 14 }}>
          {sections.map((section) => (
            <section key={section.title} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, padding: '1rem 1rem 1.1rem' }}>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.2rem', marginBottom: '0.55rem', color: 'var(--text-primary)' }}>
                {section.title}
              </h2>
              <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: section.bullets?.length ? 10 : 0 }}>
                {section.body}
              </p>
              {section.bullets?.length ? (
                <ul style={{ marginLeft: 18, color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                  {section.bullets.map((item) => <li key={item}>{item}</li>)}
                </ul>
              ) : null}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
